import { Building2, Mail, Shield, User } from "lucide-react";
import { PageHeader, Panel, Overline } from "@/components/Panel";
import { useAuth } from "@/context/AuthContext";

const AccountRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-center justify-between gap-4 py-4 border-b border-line last:border-0">
    <span className="flex items-center gap-2 text-sm text-ink-secondary"><Icon size={16} className="text-brand" />{label}</span>
    <span className="text-sm font-semibold text-ink text-right">{value || "—"}</span>
  </div>
);

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="h-full flex flex-col animate-fade-in max-w-[900px] mx-auto w-full">
      <PageHeader title="Cuenta" subtitle="Identidad autenticada y tenant de datos" testId="settings-header" />
      <Panel className="p-6">
        <Overline className="mb-2">Sesión actual</Overline>
        <AccountRow icon={User} label="Nombre" value={user?.display_name} />
        <AccountRow icon={Mail} label="Correo" value={user?.email} />
        <AccountRow icon={Building2} label="Cliente" value={user?.tenant?.name} />
        <AccountRow icon={Shield} label="Rol" value={user?.role === "customer" ? "Cliente" : user?.role} />
      </Panel>
      <p className="text-xs text-ink-tertiary mt-4">La edición de cuenta, recuperación de contraseña y preferencias se incorporarán en una fase posterior.</p>
    </div>
  );
}
